export const aiQuestions: string[] = [
  'Welche Ziele verfolgt die Ausschreibung konkret?',
  'Gibt es bestimmte Umwelt- oder Nachhaltigkeitsstandards, die erfüllt werden müssen?',
  'Ist die Ausschreibung für kleine und mittlere Unternehmen (KMU) geeignet?',
  'Sind Referenzen für die Teilnahme erforderlich?',
  'Gibt es spezifische technische Anforderungen, die erfüllt werden müssen?',
  'Welche Qualifikationen oder Zertifizierungen müssen Anbieter nachweisen?',
  'Müssen alternative Angebote oder Innovationen explizit angegeben werden?',
  'Gibt es eine Nachfrist, falls Unterlagen fehlen oder Informationen unklar sind?',
  'Wird eine finanzielle Sicherheit oder Bürgschaft verlangt?',
  'Welche Zahlungsbedingungen gelten für den Auftrag?',
  'Welche Gewichtung haben die einzelnen Bewertungskriterien?',
  'Welche Bedeutung haben Qualität und Preis im Bewertungsverfahren?',
  'Gibt es zusätzliche Punkte für bestimmte Referenzen oder Erfahrungen?',
  'Welche Dokumente müssen dem Angebot beigefügt werden?',
  'Gibt es eine bestimmte Form, in der das Angebot eingereicht werden muss?',
  'Gibt es eine detaillierte Aufgabenbeschreibung oder einen Zeitplan für das Projekt?',
  'Welche Vorarbeiten sind vor Beginn der Ausführung erforderlich?',
  'Ist der Projektzeitraum flexibel, oder gibt es fixe Deadlines für die Fertigstellung?',
  'Gibt es Optionen zur Vertragsverlängerung?',
  'Wie wird mit Vertragsstrafen bei verspäteter Lieferung umgegangen?',
  'Welche Vertragslaufzeit ist vorgesehen?',
  'Wer ist der Hauptansprechpartner für Rückfragen während der Ausschreibung?',
  'Gibt es eine bevorzugte Kontaktmethode für Rückfragen oder Updates?',
  'Wie viele Lose umfasst diese Ausschreibung und was sind die Unterschiede?',
  'Können sich Bieter nur auf einzelne Lose oder auf alle gleichzeitig bewerben?',
  'Gibt es spezifische Anforderungen oder Kriterien, die nur für bestimmte Lose gelten?',
  'Gibt es bestimmte Risiken, die in der Ausschreibung genannt werden?',
  'Müssen Compliance-Richtlinien oder Datenschutzstandards eingehalten werden?',
  'Werden bestimmte Maßnahmen zur Risikominimierung erwartet?',
  'Dürfen Subunternehmer oder Partnerunternehmen eingesetzt werden?',
  'Muss der Anbieter lokale Niederlassungen oder einen Standort in der Nähe des Einsatzorts haben?',
  'Gibt es besondere logistische Anforderungen für die Projektdurchführung?',
  'Welche Nachweise oder Berichte sind am Ende des Projekts zu liefern?',
  'Gibt es spezielle Abnahmekriterien für die Projektleistungen?',
  'Sind Abschlussdokumentationen oder Zertifikate erforderlich?',
  'Gibt es einen geplanten Ortstermin oder eine Bieterversammlung für interessierte Anbieter?',
  'Was sind die Kriterien für die Vergabe des Auftrags und wie werden sie gewichtet?',
  'Was sind die wichtigsten Projektmeilensteine und deren erwartete Fertigstellungstermine?',
];
